import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import "firebase/compat/firestore";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAWvKSxw_yKSJjgw4SpOi1gDmUkiHx3z6c",
  authDomain: "gallery-app-654f6.firebaseapp.com",
  projectId: "gallery-app-654f6",
  storageBucket: "gallery-app-654f6.appspot.com",
  messagingSenderId: "289253585352",
  appId: "1:289253585352:web:e471edbc9e8801e061d0fd",
  measurementId: "G-Y0XDF66LYQ",
};

firebase.initializeApp(firebaseConfig);

const projectStorage = firebase.storage();
const projectFirestore = firebase.firestore();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { projectFirestore, projectStorage, timestamp };
